import { FieldValue, serverTimestamp } from '@angular/fire/firestore';

import type { UserFavoritesDoc } from '../../core/interfaces/layout.interface';

/**
 * Builds the Firestore payload for a favorites document write.
 *
 * Documents created before `created_at` existed are read back with `created_at: undefined`,
 * and Firestore rejects `undefined` field values, so the field is stamped with the server
 * time instead of being carried over empty.
 *
 * @param favDoc - Favorites document as held in memory
 * @returns Payload with no `undefined` values
 * @example
 * toFavoritesPayload({ id: 'u1', userId: 'u1', folders: [], items: [] }).created_at; // FieldValue
 */
export function toFavoritesPayload(
  favDoc: UserFavoritesDoc,
): Omit<UserFavoritesDoc, 'created_at'> & { created_at: Date | FieldValue } {
  return { ...favDoc, created_at: favDoc.created_at ?? serverTimestamp() };
}
